function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Tabs, Modal, message, Alert, ColorPicker, List, Drawer, Select } from "antd";
import { FileEarmarkBreakFill, ShareFill, Pc, FolderFill } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import moment from 'moment';
import WorkbookInsideView from "../WorkbookInsideView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var TabPane = Tabs.TabPane;
var confirm = Modal.confirm;
var EditWorkbook = function EditWorkbook(_ref) {
  var hanlder = _ref.hanlder,
    workbook = _ref.workbook;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(workbook.color),
    _useState8 = _slicedToArray(_useState7, 2),
    color = _useState8[0],
    setColor = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataChanged = _useState0[0],
    setIsDataChanged = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    yearOptions = _useState10[0],
    setYearOptions = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("div", {
        children: ["La modification du classeur ", values.label]
      }),
      onOk: function onOk() {
        setIsDataLoading(true);
        axios.post(Common.baseApiUrl + 'editworkbook', _defineProperty(_defineProperty(_defineProperty({
          id: workbook.id,
          wbcolor: workbook.color,
          label: values.label,
          year: values.year
        }, "wbcolor", color), "description", values.description), "user_id", Common.currentUser.id)).then(function (response) {
          if (response.data.status == 200) {
            hanlder();
          } else {
            setErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        })["finally"](function () {
          setIsDataLoading(false);
        });
      }
    });
  };
  var handleColorChange = function handleColorChange(c) {
    setColor(c.toHexString());
  };
  useEffect(function () {
    var start = 2010;
    var end = 2030;
    var _loop = function _loop(i) {
      setYearOptions(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          value: i,
          label: i
        }]);
      });
    };
    for (var i = start; i <= end; i++) {
      _loop(i);
    }
    form.setFieldsValue({
      label: workbook.label,
      description: workbook.description,
      year: workbook.year
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            message: errorMessage,
            type: "error",
            banner: true
          }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
            message: successMessage,
            type: "success",
            banner: true
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
            form: form,
            layout: "vertical",
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "label",
              label: "Nom du classeur",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Input, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "description",
              label: "Description",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(TextArea, {
                placeholder: "Entrer la description ici"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "year",
              label: "Ann\xE9e de cr\xE9ation",
              rules: [{
                required: true,
                message: 'Champs obligatoire'
              }],
              children: /*#__PURE__*/_jsx(Select, {
                options: yearOptions
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              label: "Choisir la couleur",
              children: /*#__PURE__*/_jsx(ColorPicker, {
                trigger: "hover",
                defaultValue: color,
                onChange: handleColorChange,
                presets: [{
                  label: "Recommandations",
                  colors: ['#F5222D', '#FA8C16', '#FADB14', '#8BBB11', '#52C41A', '#13A8A8', '#1677FF', '#2F54EB', '#722ED1', '#EB2F96']
                }]
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                htmlType: "submit",
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: " SAUVEGARDER"
                })
              })
            })]
          })]
        })
      })
    })
  });
};
export default EditWorkbook;